import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OESportTargetType, OESportTargets, OESportFeatureAccess, OESportStartSelectionData} from './oe-sport-model';

export default class OESportCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OESportTargetType.anatomy]:        {icon: OEIconCodes.sport.anatomyTarget, noTargetTypeBarEntry: true, titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = OESportStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OESportTargets}
                featureAccess={OESportFeatureAccess}
                startSelectionData={OESportStartSelectionData}
            />
        );
    }
}